import { IAuditItem } from 'modules/audit/management/interfaces/IAuditItem';
import { FieldType } from 'modules/settings/templates/main/interfaces';

export const auditItemDefaults: IAuditItem = {
  auditSection: '',
  text: '',
  norms: [],
  answerType: FieldType.TEXT,
  answerConfig: {
    items: [],
    scoreable: false,
  },
  order: 0,
  answer: {},
  audit: '',
};
